import {
  REQUEST_CURRENT_SESSION,
  RECEIVE_CURRENT_SESSION,
  RECEIVE_CURRENT_SESSION_INFLUENCER,
  LOGOUT,
} from "./session_actions";
import {
  RECEIVE_SERVER_ERRORS,
  SERVER_DOWN_ERROR,
  RESET_LOADING,
} from "../Shared/Errors/errorActions";
import { getCurrentBrandIfTryAndBuy } from "../utilities";

export const nullSession = {
  currentUser: {},
  roles: [],
  brands: [],
  userPicture: null,
  currentBrand: null,
  brandPicture: null,
  competitor: null,
  competitorPicture: null,
  influencer: {},
  influencerStatistics: {},
  tryAndBuyConfigurations: {},
  loading: false,
  serverDownModal: false,
  lastSignInAt: "",
};

const sessionReducer = (state = nullSession, payload = {}) => {
  const { type, session, influencer, serverDownModal } = payload;
  switch (type) {
    case REQUEST_CURRENT_SESSION:
      return { ...state, loading: true };
    case RECEIVE_CURRENT_SESSION_INFLUENCER:
      return { ...state, influencer, loading: false };
    case RECEIVE_CURRENT_SESSION:
      return {
        ...state,
        ...session,
        currentBrand: getCurrentBrandIfTryAndBuy(
          session.currentBrand,
          session.currentUser && session.currentUser.try_and_buy
        ),
        loading: false,
      };
    case RECEIVE_SERVER_ERRORS:
      return { ...state, loading: false };
    case SERVER_DOWN_ERROR:
      return { ...state, serverDownModal };
    case RESET_LOADING:
      return { ...state, loading: !state.loading };
    case LOGOUT:
      return nullSession;
    default:
      return state;
  }
};

export default sessionReducer;
